/* KAENO 05/10/2026 — petits comportements des sections de marque (aucune dépendance). */
(function () {
  'use strict';

  /* 1. Apparition douce des blocs au défilement */
  function initAnim() {
    var els = document.querySelectorAll('.kb-anim:not(.est-vu)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('est-vu'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('est-vu'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2. Date de livraison estimée : expédition sous 48 h ouvrées + 4 à 7 jours (réglable par data-min / data-max, en jours calendaires) */
  function initLivraison() {
    var mois = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    function fmt(d) { return d.getDate() + ' ' + mois[d.getMonth()]; }
    document.querySelectorAll('[data-kb-livraison]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '5', 10);
      var max = parseInt(el.getAttribute('data-max') || '10', 10);
      var a = new Date(), b = new Date();
      a.setDate(a.getDate() + min); b.setDate(b.getDate() + max);
      el.textContent = 'entre le ' + fmt(a) + ' et le ' + fmt(b);
    });
  }

  /* 3. Offres : le bouton affiche le prix de l'offre cochée */
  function initOffres() {
    document.querySelectorAll('[data-kb-offre]').forEach(function (form) {
      var prix = form.querySelector('[data-kb-prix-bouton]');
      function maj() {
        var c = form.querySelector('input[name="id"]:checked');
        if (c && prix) prix.textContent = c.getAttribute('data-prix') || '';
      }
      form.addEventListener('change', maj);
      maj();
    });
  }

  /* 4. Barre « Commander ici » collante sur mobile : visible après le haut de page, cachée quand l'offre est à l'écran */
  function initCollant() {
    var barre = document.querySelector('[data-kb-collant]');
    if (!barre || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('[data-kb-hero]');
    var offre = document.getElementById('commander');
    var heroVu = true, offreVue = false;
    function maj() { barre.classList.toggle('est-visible', !heroVu && !offreVue); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === hero) heroVu = en.isIntersecting;
        if (en.target === offre) offreVue = en.isIntersecting;
      });
      maj();
    }, { threshold: 0 });
    if (hero) io.observe(hero);
    if (offre) io.observe(offre);
  }

  /* 5. Avant / après : le curseur fait glisser la séparation */
  function initAvantApres() {
    document.querySelectorAll('[data-kb-aa]').forEach(function (box) {
      var r = box.querySelector('input[type=range]');
      if (!r || r.dataset.kbOk) return; r.dataset.kbOk = '1';
      function maj() { box.style.setProperty('--pos', r.value + '%'); }
      r.addEventListener('input', maj); maj();
    });
  }

  /* 6. Avis : défilement automatique doux (pause au toucher / survol / hors écran / mouvement réduit) */
  function initAvis() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-kb-avis]').forEach(function (piste) {
      if (piste.dataset.kbOk) return; piste.dataset.kbOk = '1';
      var cartes = piste.children; if (cartes.length < 3) return;
      var pause = false, i = 0, vu = false;
      ['pointerdown', 'touchstart', 'mouseenter', 'focusin', 'wheel'].forEach(function (ev) { piste.addEventListener(ev, function () { pause = true; }, { passive: true }); });
      piste.addEventListener('mouseleave', function () { pause = false; });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vu = e[0].isIntersecting; }).observe(piste);
      setInterval(function () {
        if (pause || !vu) return;
        i = (i + 1) % cartes.length;
        piste.scrollTo({ left: cartes[i].offsetLeft - piste.offsetLeft - 20, behavior: 'smooth' });
      }, 4200);
    });
  }


  /* 7. Fiche : la ligne sous le prix suit l'offre cochée (« Prix du Pack de 2 · ou 1 sangle seule à 24,90 € ») */
  function initPrixOffre() {
    function maj() {
      var el = document.querySelector('[data-kb-prix-offre]');
      var c = document.querySelector('variant-picker input[type=radio]:checked');
      if (!el || !c) return;
      var mini = el.getAttribute('data-mini') || '';
      var t = c.value;
      var t1 = el.getAttribute('data-t1') || 'Prix pour %v';
      var t2 = el.getAttribute('data-t2') || 'Prix du %v · ou 1 sangle seule à <strong>%m</strong>';
      if (/^1\s/.test(t)) el.textContent = t1.replace('%v', t);
      else el.innerHTML = t2.replace('%v', t).replace('%m', mini);
    }
    if (window.__kbPrixOffre) { maj(); return; }
    window.__kbPrixOffre = true;
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-picker')) setTimeout(maj, 0); });
    document.addEventListener('variant:update', function () { setTimeout(maj, 50); });
    maj();
  }

  function init() { initAnim(); initLivraison(); initOffres(); initCollant(); initAvantApres(); initAvis(); initPrixOffre(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
